import { AppContext } from 'contexts/AppContext';
import React, { useContext } from 'react';
import Header from 'components/Header/Header';
import { useParams, useSearchParams } from 'react-router-dom';
import JobsTable from 'components/JobsTable/JobsTable';
import { FormattedMessage } from 'react-intl';

function TableDetailsPage() {
  const { tableName } = useParams<{ tableName: string }>();
  const [searchParams] = useSearchParams();
  const schema = searchParams.get('schema') ?? '';
  const { clusterName } = useContext(AppContext);

  return (
    <>
      <Header>
        <FormattedMessage id="header.jobsOfCluster" values={{ clusterName }} />
      </Header>
      <JobsTable
        lockedTableFilter={tableName ? [tableName] : []}
        lockedSchemaFilter={schema ? [schema] : []}
      />
    </>
  );
}

export default TableDetailsPage;
